import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { User } from "../services";
import { AuthContext } from "../context/auth.context";
import { configData } from "../services/api-config";
import { useTranslation } from "react-i18next";

export const useRegistration = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  const handleLogin = async (email, password, userType) => {
    const payload = {
      username: email ? email.toLowerCase() : email,
      password: password,
    };

    if (!payload.username || !payload.password) {
      toast.error(t("registrationSurveyUserSecond.toast.loginError"));
      return;
    }

    try {
      const response = await axios.get(configData.BASE_URL + "api/v1/users/login", {
        auth: payload,
        withCredentials: true,
      });

      if (response.status === 200) {
        response.data.isAuthenticated = true;
        auth.login(response.data.accessToken);

        if (userType === "expeditor") {
          navigate("/onboarding-expeditor");
        } else {
          navigate("/onboarding");
        }
      }
    } catch (error) {
      toast.error(t("registrationSurveyUserSecond.toast.loginError") + ": " + error.message);
      throw error;
    }
  };

  const performRegistration = async (registrationData, code = null, clientId = null) => {
    setIsLoading(true);
    try {
      const { isChecked, ...newData } = registrationData;

      if (clientId && code) {
        await User.registerInvitationExpeditor(clientId, code, newData);
      } else {
        await User.registerNew(newData);
      }

      toast.success(t("registrationSurveyUserSecond.toast.registrationSuccess"));

      await handleLogin(registrationData.email, registrationData.password, registrationData.type);
    } catch (error) {
      console.error("Ошибка при регистрации нового пользователя:", error);
      toast.error(t("registrationSurveyUserSecond.toast.registrationError"));
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleLogin,
    performRegistration,
  };
};
